import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { RadioGroup } from '../../../../components/RadioGroup';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import { getFlagFromStatus, getStatusByFlag } from '../../../../types/boolean-flag';
import type {
  QuickBooksConfigurationControl,
  QuickBooksConfigurationFormValues,
} from '../../QuickBooksConfigurationFormSchema';
import { AUTOMATICALLY_SYNC_CREDIT_MEMOS_OPTIONS } from './constants';

type CreditMemosConfigurationSectionProps = {
  control: QuickBooksConfigurationControl;
  defaultValues: QuickBooksConfigurationFormValues;
};

export const CreditMemosConfigurationSection: FC<CreditMemosConfigurationSectionProps> = ({
  control,
  defaultValues,
}) => (
  <ConfigurationSection title="Credit Memos" iconName="CreditCard">
    <Controller
      name="autoExportCreditMemos"
      control={control}
      defaultValue={defaultValues.autoExportCreditMemos}
      render={({ field: { value, onChange } }) => (
        <RadioGroup
          title="Choose how to sync credit memos"
          value={getFlagFromStatus(value)}
          onChange={(selected) => onChange(getStatusByFlag(selected))}
          keyExtractor={(option) => option.value}
          options={AUTOMATICALLY_SYNC_CREDIT_MEMOS_OPTIONS}
        />
      )}
    />
  </ConfigurationSection>
);
